import React, { useState, useEffect, useMemo, useCallback } from "react";
import { secondsToTime } from "../../utilities/scoringUtilities";

import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import ScoringInputDetailModal from "../Modals/ScoringInputDetailModal";
import DeletePlayerPopupModal from "../Modals/DeletePlayerPopupModal";
import { ScoringInputType } from "../../models/enums/ScoringInputType";
import UseFullPageLoaderHook from '../Modals/Hook/UseFullPageLoaderHook';
import { v4 as uuidv4 } from 'uuid';
import { useLocation } from 'react-router';
import queryString from 'query-string';

import ContextMenu from './ContextMenu';


import "./InputTable.css";
import { MatchEvents } from "../../models/enums/MatchEvents";
const InputTable = (props) => {
    const {
        inputItemList,
        deleteAction,
        jumpVideoPlayer,
        errorIds,
        height,
        fixtureRoomId,
        setIsCardHighlighted,
        onFlagClick,
        time,
        getCurrentTime,
        setScoreErrorMessages,
        setInfoMessages,
        setSelectedPlayer,
        showScoringInputDetailModal,
        setScoringInputDetailModal,
        setClipSelected
    } = props;
    const [showDeletedPlayerScoreMidClipPopupModal, setShowDeletedPlayerScoreMidClipPopupModal] = useState(false);
    const [modalData, setModalData] = useState();
    const [deleteData, setDeleteData] = useState();
    const [loading, setLoading] = useState(true);
    const [loader, showLoader, hideLoader] = UseFullPageLoaderHook();
    const { search } = useLocation();

    const editType = [ScoringInputType.ClipEnd, ScoringInputType.ClipStart, ScoringInputType.PlayerScore];

    const isKickOffOrPenalty = useCallback((type, endReason, startReason) => {
        if (type == ScoringInputType.ClipStart && startReason == MatchEvents.Kickoff) return false;
        if (type == ScoringInputType.ClipEnd && endReason == MatchEvents.PenaltyTry) return false;
        return true;
    }, [])

    useEffect(() => {
        const values = queryString.parse(search)
        const inputTable = document.getElementById("inputTable");
        const newPositionIndex = Math.round(inputItemList?.filter(x => x.time === time)[0]?.time);
        if (newPositionIndex) {
            const newPosition = document.getElementById(newPositionIndex);
            inputTable.scrollTo({
                top: newPosition.offsetTop - 40
            });
        }
        else if (values.time) {
            const reviewPosition = document.getElementById(Math.round(values.time));
            if (reviewPosition) {
                inputTable.scrollTo({
                    top: reviewPosition.offsetTop - 40
                })
            };
        }
    }
        , [inputItemList])
    const columnHeading = [
        { key: "id", value: "#" },
        { key: "Clip", value: "Clip #" },
        { key: "Half", value: "Half" },
        { key: "Event", value: "Event" },
        { key: "Time", value: "Time" },
        { key: "Player", value: "Player" },
        { key: "Details", value: "Details" },
        { key: "SetPiecesInfo", value: "Set Pieces Info" },
        { key: "XY", value: "XY" },
        { key: "Raw", value: "Raw" },
        { key: "Calc", value: "Calc" },
        { key: "Adj_Calc", value: "Adj Calc" },
        { key: "Supremacy", value: "Supremacy" },
        { key: "Adj", value: "Adj" },
    ];
    const [columnShow, setColumnShow] = useState({
        id: true,
        Clip: true,
        Half: true,
        Event: true,
        Time: true,
        Player: true,
        Details: true,
        SetPiecesInfo: true,
        XY: true,
        Raw: true,
        Calc: true,
        Adj_Calc: true,
        Supremacy: true,
        Adj: true,
    });

    const anyColumnHidden = Object.values(columnShow).some(value => !value);

    useEffect(() => {
        if (modalData) setScoringInputDetailModal(true);
        setLoading(false);
    }, [modalData]);

    useEffect(() => {
        if (inputItemList?.filter(x => (x.kValue < 0.5 || x.kValue > 2.5) && x.type === ScoringInputType.PlayerScore).length > 0) {
            setInfoMessages([{ id: uuidv4(), text: "Clip number needs reviewed: " + Array.from(new Set(inputItemList?.filter(x => (x.kValue <= 0.5 || x.kValue > 2.5) && x.type === ScoringInputType.PlayerScore).map(e => e.clipNumber))).join(", ") }]);
        }
    }, [inputItemList])

    useEffect(() => {
        if (deleteData) setShowDeletedPlayerScoreMidClipPopupModal(true);
        setLoading(false);
    }, [deleteData]);

    const TableRow = ({ rowData, x, cur }) => {
        let key = x.id + "_" + x.type;
        let rowClass =
            errorIds &&
                errorIds.length > 0 &&
                errorIds.filter((y) => y == x.id).length > 0
                ? "table-danger"
                : "";
        return (
            <tr id={Math.round(x.time)} style={x.groupId
                && inputItemList.filter((y) => y.groupId === x.groupId).length > 1
                && cur.isInClip && !cur.requiresClipEnd
                && x.type === ScoringInputType.PlayerScore ? { borderStyle: "solid", borderColor: "#007BFF" } :
                ((!cur.isInClip || cur.isInClip && cur.requiresClipEnd)
                    && (x.type === ScoringInputType.PlayerScore
                        || x.type === ScoringInputType.RedCard
                        || x.type === ScoringInputType.YellowCard
                        || x.type === ScoringInputType.RedCardReturned
                        || x.type === ScoringInputType.YellowCardReturned)
                    || (x.type === ScoringInputType.ClipStart && cur.isInClip && cur.requiresClipEnd)) ? { borderStyle: "solid", borderColor: "red" } :
                    {}} key={key} className={rowClass}>
                {rowData
                    .filter((_, index) => Object.values(columnShow)[index])
                    .map((x) => (
                        <td>{x}</td>
                    ))}
                <td>
                    {(x.type != ScoringInputType.FirstHalfStart &&
                        x.type != ScoringInputType.SecondHalfStart &&
                        x.type != ScoringInputType.FirstHalfEnd &&
                        x.type != ScoringInputType.SecondHalfEnd &&
                        x.type != ScoringInputType.RefDecision) &&
                        <a style={{ cursor: "pointer" }}
                            onClick={async (clickInfo) => {
                                await onFlagClick(x.type, x.id);
                            }}>
                            <i
                                className="fas fa-fw fa-flag"
                                style={{ color: x.isFlagged ? "red" : "grey" }}
                            ></i>
                        </a>
                    }
                </td>
                <td>
                    {x.type != ScoringInputType.MidClip && (
                        <a
                            style={{ cursor: "pointer" }}
                            onClick={async () => {
                                try {
                                    let inputListWithOutsideScoring = inputItemList?.filter(x => (!getCurrentTime(x.time, inputItemList).isInClip || getCurrentTime(x.time, inputItemList).isInClip && getCurrentTime(x.time, inputItemList).requiresClipEnd)
                                        && (x.type === ScoringInputType.PlayerScore || x.type === ScoringInputType.YellowCard || x.type === ScoringInputType.RedCard)).map(t => ({ time: secondsToTime(t.time), playerScoreId: t.id }));
                                    if (x.type == ScoringInputType.YellowCard || x.type == ScoringInputType.YellowCardReturned
                                        || x.type == ScoringInputType.RedCard || x.type == ScoringInputType.RedCardReturned) {
                                        showLoader();
                                        await deleteAction(x.type, x.id);
                                        await setIsCardHighlighted(true);
                                        hideLoader();
                                    }
                                    else if (inputItemList?.filter(x => x.type === ScoringInputType.MidClip).map(x => x.id).includes(x.id)) {
                                        setDeleteData({
                                            ...x,
                                            currentSupremacy: getSupremacyPoint(
                                                x.type,
                                                x.clipStartSupremacy,
                                                x.clipEndSupremacy,
                                                x.actionSupremacy
                                            ),
                                            type: x.type,
                                            id: x.id
                                        });
                                    }
                                    else {
                                        await deleteAction(x.type, x.id);
                                    }

                                    if (x.type !== ScoringInputType.ClipEnd || x.type !== ScoringInputType.ClipStart) {
                                        inputListWithOutsideScoring = inputListWithOutsideScoring.filter((e) => !(e.time === secondsToTime(x.time) && e.playerScoreId === x.id));
                                        inputListWithOutsideScoring.length > 0 ? setScoreErrorMessages([{ id: uuidv4(), text: "Scores are outside clip at " + Array.from(new Set(inputListWithOutsideScoring.map(e => e.time))).join(",") }]) : setScoreErrorMessages(null);
                                    }
                                    else {
                                        setScoreErrorMessages(null);
                                    }
                                }
                                catch (err) {
                                    hideLoader();
                                    if (err) {
                                        setScoreErrorMessages([{ id: uuidv4(), text: err.data?.error ? err.data?.error : err.data }]);
                                    } else {
                                        setScoreErrorMessages([{ id: uuidv4(), text: "An error occurred" }]);
                                    }
                                }
                            }}
                        >
                            <i
                                className="fas fa-fw fa-trash"
                                style={{ color: "red" }}
                            ></i>
                        </a>
                    )}
                </td>
                <td>
                    {editType.includes(x.type) && isKickOffOrPenalty(x.type, x.clipEndReason, x.clipStartReason) && (
                        <a
                            style={{ cursor: "pointer" }}
                            onClick={async () => {
                                try {
                                    if (x.type === ScoringInputType.PlayerScore) {
                                        setSelectedPlayer({
                                            ...x,
                                            currentScore: x.score,
                                            isRedCard: (x.type === ScoringInputType.RedCard) ? true : false,
                                            isYellowCard: (x.type === ScoringInputType.YellowCard) ? true : false,
                                            key: x.playerScoreKey,
                                            numberOfAction: 1,
                                            playerId: "",
                                            playerName: "",
                                            playerShirtNumber: x.playerShirtNumber,
                                            teamId: x.teamId,
                                            shirtNumber: x.shirtNumber,
                                            categorizations: x.categorizations,
                                            playerScoreDescriptions: x.playerScoreDescriptions
                                        });
                                    }
                                    else {
                                        setClipSelected({
                                            ...x,
                                            clipEndSupremacy: x.clipEndSupremacy,
                                        });
                                    }
                                }
                                catch (err) {
                                    if (err) {
                                        setScoreErrorMessages([{ id: uuidv4(), text: err.data?.error ? err.data?.error : err.data }]);
                                    } else {
                                        setScoreErrorMessages([{ id: uuidv4(), text: "An error occurred" }]);
                                    }
                                }
                            }}
                        >
                            <i
                                className="fas fa-fw fa-pencil"
                            ></i>
                        </a>
                    )}
                </td>
            </tr>
        );
    };

    const IdCell = ({ index }) => {
        return <>{index}</>;
    };

    const ClipCell = ({ cur, x }) => {
        return ((!cur.isInClip || cur.isInClip && cur.requiresClipEnd) && (x.type === ScoringInputType.PlayerScore || x.type === ScoringInputType.YellowCard || x.type === ScoringInputType.RedCard)) ?
            <></>
            :
            <>{x.clipNumber}</>;
    };

    const HalfCell = ({ cur, x }) => {
        return ((!cur.isInClip || cur.isInClip && cur.requiresClipEnd) && (x.type === ScoringInputType.PlayerScore || x.type === ScoringInputType.YellowCard || x.type === ScoringInputType.RedCard)) ?
            <></>
            :
            <>{x.half === 0 ? "" : x.half}</>;
    };

    const EventCell = ({ x }) => {
        return <>{abbreviatedEvent.get(x.typeText)}</>;
    };

    const TimeCell = ({ x }) => {
        return <a
            href="#"
            style={{ cursor: "pointer" }}
            onClick={async (clickInfo) => {
                clickInfo.preventDefault();

                jumpVideoPlayer(x.time);

                return false;
            }}
        >
            {secondsToTime(x.time)}
        </a>;
    };

    const PlayerCell = ({ x }) => {
        return <>{x.type == ScoringInputType.PlayerScore && (
            <>
                <span>
                    {x.teamAbbreviation}
                    {x.playerShirtNumber}{" "}
                </span>
            </>
        )}
            {x.type == ScoringInputType.TeamScore && (
                <>
                    <span>
                        {x.teamAbbreviation}
                    </span>
                </>
            )}</>
    };

    const DetailsCell = ({ x }) => {
        return <>{x.type == ScoringInputType.PlayerScore && (
            <>
                <span>{x.categorizationsText}</span>
                <span> {x.playerDescriptionsText} </span>
            </>
        )}
            {x.type == ScoringInputType.TeamScore && (
                <>
                    <span>{x.categorizationsText}</span>
                    <span> {x.teamDescriptionsText} </span>

                </>
            )}
            {x.type == ScoringInputType.MidClip && (
                <>
                    <span>{x.midClipText}</span>
                </>
            )}
            {x.type == ScoringInputType.ClipStart && (
                <>
                    <span>{x.clipStartText}</span>
                </>
            )}

            {x.type == ScoringInputType.ClipEnd && (
                <>
                    <span>{x.clipEndText}</span>
                </>
            )}

            {x.type == ScoringInputType.YellowCard && (
                <>
                    <span>{x.cardScoreText}</span>
                </>
            )}

            {x.type == ScoringInputType.RedCard && (
                <>
                    <span>{x.cardScoreText}</span>
                </>
            )}

            {x.type == ScoringInputType.YellowCardReturned && (
                <>
                    <span>{x.cardScoreText}</span>
                </>
            )}

            {x.type == ScoringInputType.RedCardReturned && (
                <>
                    <span>{x.cardScoreText}</span>
                </>
            )}
            {x.type == ScoringInputType.Try && (
                <>
                    <span>{x.tryText}</span>
                </>
            )}
            {x.type == ScoringInputType.RefDecision && (
                <>
                    <span>{x.categorizationsText}</span>
                </>
            )}</>
    };

    const SetPiecesInfoCell = ({ x }) => {
        return <>{x.clipEndReason === MatchEvents.Penalty && x.type === ScoringInputType.ClipEnd ? (
            <>
                <span>{x.penaltyReasonText}</span>
            </>
        ) : x.clipStartReason == MatchEvents.Scrum ?
            (<>
                <span>{x.matchEventWonText}{abbreviatedEvent.get(x.penaltyResultText)}{abbreviatedEvent.get(x.freeKickText)} </span>

            </>
            )
            :
            (<>
                <span>{x.matchEventWonText}{x.lineoutTargetText}{abbreviatedEvent.get(x.freeKickText)} </span>
            </>)}
        </>
    };

    const XYCell = ({ x }) => {
        return <>
            {x.type == ScoringInputType.PlayerScore && (
                <>
                    <span>{x.playerScoreText}</span>
                </>
            )}
            {x.type == ScoringInputType.TeamScore && (
                <>
                    <span>{x.teamScoreText}</span>
                </>
            )}
            {x.type == ScoringInputType.ClipStart && (
                <>
                    <span>{x.clipStartPositionText}</span>
                </>
            )}
            {x.type == ScoringInputType.ClipEnd && (
                <>
                    <span>{x.clipEndPositionText}</span>
                </>
            )}
            {x.type == ScoringInputType.Try && (
                <>
                    <span>{x.tryPositionText}</span>
                </>
            )}</>
    };

    const RawCell = ({ x }) => {
        let scoreClass =
            x.type == ScoringInputType.PlayerScore || ScoringInputType.TeamScore
                ? x.score >= 0
                    ? "text-success"
                    : "text-danger"
                : "";
        return <>
            <span className={scoreClass}>
                {x.scoreText ? x.scoreText : ""}{" "}
            </span>
        </>
    };

    const CalcCell = ({ cur, x }) => {
        let calcScoreClass =
            x.type == ScoringInputType.PlayerScore || ScoringInputType.TeamScore
                ? x.score >= 0
                    ? "H"
                    : "A"
                : "";

        return x.type != ScoringInputType.YellowCard
            && x.type != ScoringInputType.YellowCardReturned
            && x.type != ScoringInputType.RedCard
            && x.type != ScoringInputType.RedCardReturned
            && cur.isInClip
            && !cur.requiresClipEnd
            && (
                <>
                    <span className={calcScoreClass} style={{ color: x.kValue < 0 && x.type === ScoringInputType.PlayerScore ? "red" : ((x.kValue >= 0 && x.kValue < 0.5) || x.kValue > 2.5) && x.type === ScoringInputType.PlayerScore ? "orange" : "" }}>
                        {inputItemList.some((x) => x.type === ScoringInputType.MidClip)
                            ? ""
                            : Math.round(x.calculatedPoint * 1000) / 1000}
                    </span>
                </>
            )
    };

    const AdjCalcCell = ({ cur, x }) => {
        let calcScoreClass =
            x.type == ScoringInputType.PlayerScore || ScoringInputType.TeamScore
                ? x.score >= 0
                    ? "H"
                    : "A"
                : "";

        return x.type != ScoringInputType.YellowCard
            && x.type != ScoringInputType.YellowCardReturned
            && x.type != ScoringInputType.RedCard
            && x.type != ScoringInputType.RedCardReturned
            && cur.isInClip
            && !cur.requiresClipEnd
            && (
                <>
                    <span className={calcScoreClass} style={{ color: x.kValue < 0 && x.type === ScoringInputType.PlayerScore ? "red" : (x.kValue > 0 && x.kValue < 0.5) || x.kValue > 2.5 && x.type === ScoringInputType.PlayerScore ? "orange" : "" }}>
                        {inputItemList.some((x) => x.type === ScoringInputType.MidClip)
                            ? Math.round(x.calculatedPoint * 1000) / 1000
                            : ""}
                    </span>
                </>
            )
    };

    const SupremacyCell = ({ cur, x }) => {
        return cur.isInClip && !cur.requiresClipEnd && (
            <>
                {getSupremacyPoint(
                    x.type,
                    x.clipStartSupremacy,
                    x.clipEndSupremacy,
                    x.actionSupremacy
                )}
            </>
        )
    };

    const AdjCell = ({ cur, x, index }) => {
        let scoringControls = TableDetailControl(
            x.type,
            inputItemList[index]?.id,
            inputItemList[index + 1]?.id,
            x.userEnteredSupremacy
        );
        return cur.isInClip && !cur.requiresClipEnd && (
            <>
                <span>
                    {x.userEnteredSupremacy != null ? x.userEnteredSupremacy : ""}
                </span>
                <a
                    style={{ cursor: "pointer" }}
                    className="ml-1"
                    onClick={async (e) => {
                        setModalData({
                            ...x,
                            currentSupremacy: getSupremacyPoint(
                                x.type,
                                x.clipStartSupremacy,
                                x.clipEndSupremacy,
                                x.actionSupremacy
                            ),
                            startSupremacy:
                                Math.round(
                                    inputItemList.find(
                                        (e) =>
                                            e.clipNumber === x.clipNumber &&
                                            !!e.clipStartSupremacy
                                    )?.clipStartSupremacy * 1000
                                ) / 1000,
                            endSupremacy:
                                Math.round(
                                    inputItemList.find(
                                        (e) =>
                                            e.clipNumber === x.clipNumber &&
                                            !!e.clipEndSupremacy
                                    )?.clipEndSupremacy * 1000
                                ) / 1000,
                        });
                    }}
                >
                    {scoringControls}
                </a>
            </>
        )
    };

    let inputTableContents = useMemo(() => {
        if (!inputItemList) {
            return (
                <tr className="p-2">
                    <td colSpan="15" className="text-center">
                        Loading...
                    </td>
                </tr>
            )
        }
        return inputItemList && inputItemList.length > 0 ? (
            inputItemList.map((x, index) => {
                let key = x.id + "_" + x.type;
                let rowClass =
                    errorIds &&
                        errorIds.length > 0 &&
                        errorIds.filter((y) => y == x.id).length > 0
                        ? "table-danger"
                        : "";

                let cur = getCurrentTime(x.time, inputItemList)
                const cellList = [
                    <IdCell index={++index} />,
                    <ClipCell cur={cur} x={x} />,
                    <HalfCell cur={cur} x={x} />,
                    <EventCell x={x} />,
                    <TimeCell x={x} />,
                    <PlayerCell x={x} />,
                    <DetailsCell x={x} />,
                    <SetPiecesInfoCell x={x} />,
                    <XYCell x={x} />,
                    <RawCell x={x} />,
                    <CalcCell cur={cur} x={x} />,
                    <AdjCalcCell cur={cur} x={x} />,
                    <SupremacyCell cur={cur} x={x} />,
                    <AdjCell cur={cur} x={x} index={index} />,
                ];

                if (x.type != ScoringInputType.Try)
                    return <TableRow rowData={cellList} x={x} cur={cur} />;
            })
        ) : (
            <tr className="p-2">
                <td colSpan="15" className="text-center">
                    No Inputs
                </td>
            </tr>
        );
    }, [inputItemList, columnShow]);

    const hideScoringInputDetailModal = () => {
        setScoringInputDetailModal(false);
    };

    const showMidClipModal = () => {
        setScoringInputDetailModal(true);
    };

    const hideDeleteMidClipPopupModal = () => {
        setShowDeletedPlayerScoreMidClipPopupModal(false);
    };

    const columnHeadingRender = columnHeading.filter((y) => columnShow[y.key])
    const collect = (props) => { return { name: props.name } }

    function handleHideClick(index) {
        let indexHeading = Number(index);
        const newColumnShow = { ...columnShow };
        newColumnShow[columnHeadingRender[indexHeading].key] = false;
        setColumnShow(newColumnShow);
    }
    function handleShowClick(index) {
        let indexHeading = Number(index);
        const newColumnShow = { ...columnShow };
        if (indexHeading == 0) {
            indexHeading = 1;
            newColumnShow[columnHeading[indexHeading - 1].key] = true;
        }
        if (columnHeading.indexOf(columnHeading[indexHeading - 1].key) == -1) {
            newColumnShow[columnHeading[indexHeading + 1].key] = true;
        }
        newColumnShow[columnHeading[indexHeading].key] = true;

        setColumnShow(newColumnShow);
    }
    function showAll() {
        const newColumnShow = { ...columnShow };

        for (const key in newColumnShow) {
            if (newColumnShow.hasOwnProperty(key)) {
                newColumnShow[key] = true;
            }
        }

        setColumnShow(newColumnShow);
    }

    const getClass = (key) => {
        const index = columnHeading.map((e) => e.key).indexOf(key);
        if (index === 0) return "";
        if (!Object.values(columnShow)[index + 1] && index === Object.values(columnShow).filter(Boolean).length - 1 && index !== columnHeading.length - 1) return "show-column";
        if (!Object.values(columnShow)[index - 1]) return "show-column";
        return "";
    };

    let scoringInputDetailModal =
        modalData && !loading ? (
            <ScoringInputDetailModal
                onHide={hideScoringInputDetailModal}
                showScoringInputDetailModal={showScoringInputDetailModal}
                data={modalData}
                showMidClipModal={showMidClipModal}
                fixtureRoomId={fixtureRoomId}
                onShow={showMidClipModal}
            ></ScoringInputDetailModal>
        ) : (
            <></>
        );

    let deletedPlayerScoreMidClipPopupModal =
        deleteData && !loading ? (
            <DeletePlayerPopupModal
                onHide={hideDeleteMidClipPopupModal}
                setShowDeletedPlayerScoreMidClipPopupModal={setShowDeletedPlayerScoreMidClipPopupModal}
                showDeletedPlayerScoreMidClipPopupModal={showDeletedPlayerScoreMidClipPopupModal}
                data={deleteData}
                deleteAction={deleteAction}
            ></DeletePlayerPopupModal>
        ) : (
            <></>
        );

    return (
        <>
            <div id="inputTable"
                style={{
                    height: height,
                    maxHeight: height,
                    overflowY: "scroll",
                    overflowX: "scroll",
                    whiteSpace: "nowrap",
                }}
            >
                {anyColumnHidden && (
                    <Button
                        className=""
                        variant="outline-primary"
                        size="sm"
                        onClick={showAll}
                    >
                        Unhide Columns
                    </Button>
                )}
                <Table
                    striped
                    bordered
                    hover
                    size="sm"
                    className="react-bootstrap-table"
                    responsive
                >
                    <thead>
                        <tr>
                            {columnHeadingRender.length === 1 ? (
                                <th className="heading-column-container">
                                    {columnHeadingRender.map((x, i) => (
                                        <ContextMenu
                                            handleHide={handleHideClick}
                                            handleShow={handleShowClick}
                                            name={x.value}
                                            key={x.key}
                                            index={i}>
                                            <div className={"show-column"}>
                                                <i className="fa-solid fa-caret-left"></i>
                                                <i className="fa-solid fa-caret-right"></i>
                                            </div>
                                            <div className={'heading-column-content'}>{x.value}</div>
                                        </ContextMenu>
                                    ))}
                                </th>
                            ) : (
                                columnHeadingRender.map((x, i) => (
                                    <th className="heading-column-container" key={x.key}>
                                        <ContextMenu
                                            handleHide={handleHideClick}
                                            handleShow={handleShowClick}
                                            name={x.value}
                                            key={x.key}
                                            index={i}>
                                            {getClass(x.key) !== '' ? (
                                                <div className={getClass(x.key)}>
                                                    <i className="fa-solid fa-caret-left"></i>
                                                    <i className="fa-solid fa-caret-right"></i>
                                                </div>
                                            ) : (
                                                <></>
                                            )}
                                            <div className={'heading-column-content'}>{x.value}</div>
                                        </ContextMenu>
                                    </th>
                                ))
                            )}
                        </tr>
                    </thead>
                    <tbody>{inputTableContents}</tbody>
                </Table>
            </div>
            {scoringInputDetailModal}
            {deletedPlayerScoreMidClipPopupModal}
            {loader}
        </>
    );
};

const getSupremacyPoint = (
    type,
    clipStartSupremacy,
    clipEndSupremacy,
    actionSupremacy
) => {
    switch (type) {
        case 3:
            return clipStartSupremacy
                ? Math.round(clipStartSupremacy * 1000) / 1000
                : "";
        case 4:
            return clipEndSupremacy ? Math.round(clipEndSupremacy * 1000) / 1000 : "";
        case 5:
            return actionSupremacy ? Math.round(actionSupremacy * 1000) / 1000 : "";
        case 11:
            return actionSupremacy ? Math.round(actionSupremacy * 1000) / 1000 : "";
        case 13:
            return actionSupremacy ? Math.round(actionSupremacy * 1000) / 1000 : "";
        case 15:
            return actionSupremacy ? Math.round(actionSupremacy * 1000) / 1000 : "";
        default:
            return "";
    }
};

const TableDetailControl = (type, item, nextItem, userEnteredSupremacy) => {
    if (userEnteredSupremacy != null && type === ScoringInputType.MidClip) {
        return <i className="fas fa-fw fa-pencil"></i>;
    } else {
        if (item === nextItem) {
            return <></>;
        }
        if (type === ScoringInputType.PlayerScore) {
            return <i className="fas fa-fw fa-plus" style={{ color: "green" }}></i>;
        }
    }
};


const abbreviatedEvent = new Map([
    ["First Half Start", "1H S"],
    ["Clip Start", "Clip S"],
    ["Player Score", "Plyr Scr"],
    ["Player Red Card", "R Card"],
    ["Player Red Card Returned", "R Card Re"],
    ["Player Yellow Card", "Y Card"],
    ["Player Yellow Card Returned", "Y Card Re"],
    ["Clip End", "Clip E"],
    ["First Half End", "1H E"],
    ["Second Half Start", "2H S"],
    ["Second Half End", "2H E"],
    ["Team Score", "Team Scr"],
    ["Try", "Try"],
    ["Free Kick Against", " - FK Against"],
    ["Free Kick For", " - FK For"],
    ["Penalty Against", " - Penalty Against"],
    ["Penalty For", " - Penalty For"],
]);
export default InputTable;